<div class="inner-event">
  <div *ngIf="title" class="inner-title">{{ title }}</div>
  <div *ngIf="description" class="inner-description">{{ description }}</div>
  <div class="inner-event-content">
    <ng-content></ng-content>
  </div>
</div>
